import { render } from "./usersEditor.vue?vue&type=template&id=61beb58c&scoped=true"
import script from "./usersEditor.vue?vue&type=script&lang=js"
export * from "./usersEditor.vue?vue&type=script&lang=js"

import "./usersEditor.vue?vue&type=style&index=0&id=61beb58c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61beb58c"]])

export default __exports__